module.exports = __webpack_public_path__ + "static/media/DooTechColor.169fcf3e.svg";